import { Skeleton } from "@mui/material";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { getEstadisticasTipoHandler } from "../../../../handlers/estadisticasHandler";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { useEstadisticasStore } from "../../../../store/estadisticasStore";
import { MuniSpinner2 } from "../../../../components";
import { useEffect } from "react";


const TiposVehiculos = ({ estadisticas }) => {

    // console.log(estadisticas)
    const { loads } = useGeneralAppStore();
    const { vehiculos } = useEstadisticasStore();

    const RADIAN = Math.PI / 180;
    const COLORS = ['#30B5EC', '#1134C9', '#FFBB28', '#FF8042'];

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text fontWeight={"bolder"} fontSize={"18px"} x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(2)}%`}
            </text>
        );
    };
    useEffect(() => {
        if (!vehiculos) {
            getEstadisticasTipoHandler();
        }
        return () => {
            useEstadisticasStore.setState({ vehiculos: null })
        }
    }, [])
    console.log(vehiculos);

    return (
        <section className="d-flex justify-content-center pt-3 pb-5">
            <div style={{ width: "800px", height: "400px" }} className="  py-3">
                <h4 className="text-center">Infracciones por Vehículo: Motos y Autos</h4>
                {
                    loads.includes('estadisticas_tipo') ?
                        // <div className="w-100 d-flex justify-content-center align-items-center" style={{ height: "450px" }}>
                        //     <MuniSpinner2 />
                        // </div>
                        <div className="w-100 h-100 d-flex justify-content-center align-items-center" >
                            <Skeleton animation="wave" variant="circular" width={300} height={300} />
                        </div>
                        :

                        vehiculos &&
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart width={300} height={300}>
                                <Pie
                                    data={vehiculos?.tipos}
                                    // cx="50%"
                                    // cx={200}
                                    // cy={200}
                                    // cy="50%"
                                    labelLine={false}
                                    label={renderCustomizedLabel}
                                    // label={({ name, percent }) => {
                                    //     console.log(percent)
                                    //     return `${name}: ${(percent * 100).toFixed(0)}%`
                                    // }}
                                    outerRadius={150}
                                    // outerRadius={80}
                                    fill="#8884d8"
                                    dataKey="value"
                                >
                                    {vehiculos?.tipos.map((entry, index) => (


                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />

                                        // <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip />
                                <Legend />
                            </PieChart>
                        </ResponsiveContainer>


                }
            </div>
        </section>
    );
}
export default TiposVehiculos;